var _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#D9D9D9",
    fillOpacity: 0.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4668 19.6262L11.4602 19.6197L11.4534 19.6134C10.1567 18.4196 9.5 16.761 9.5 14.9891C9.5 11.3753 12.3939 8.5 16.0492 8.5C19.7071 8.5 22.5909 11.375 22.4978 14.9762L22.4976 14.9761V14.9891C22.4976 16.761 21.8409 18.4196 20.5442 19.6134L20.3829 19.762V19.7853C20.3756 19.7923 20.3679 19.7997 20.3599 19.8073C20.2516 19.9108 20.0938 20.0563 19.9002 20.2319C19.5141 20.5822 18.9969 21.0422 18.4747 21.5037C18.0039 21.9199 17.5217 22.3438 17.1311 22.687C16.6694 23.0929 16.3359 23.386 16.3013 23.4203C16.2677 23.4537 16.1815 23.5 16.0366 23.5C15.9036 23.5 15.7666 23.4594 15.6605 23.3869C15.4682 23.2104 14.5892 22.424 13.6989 21.6274L13.5629 21.5057C13.0467 21.0439 12.5308 20.5823 12.1377 20.2299C11.941 20.0536 11.7754 19.9049 11.6558 19.7973C11.596 19.7434 11.5481 19.7002 11.5139 19.6691C11.4921 19.6494 11.479 19.6373 11.4722 19.6311C11.4665 19.6258 11.4651 19.6246 11.4668 19.6262ZM13.5351 14.9891C13.5351 16.3675 14.6693 17.486 16.0492 17.486C17.429 17.486 18.5632 16.3675 18.5632 14.9891C18.5632 13.6106 17.429 12.4922 16.0492 12.4922C14.6693 12.4922 13.5351 13.6106 13.5351 14.9891Z",
    stroke: "#848D27"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 20,
    height: 20
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 6.5,
    width: 19,
    height: 19,
    fill: "#C4C4C4",
    stroke: "#848D27"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPin);
export default __webpack_public_path__ + "static/media/location-pin.ff23b73d2b07218318d8120f006a91f8.svg";
export { ForwardRef as ReactComponent };